module.exports = __webpack_public_path__ + "static/img/cybercrime_5.a7ef634b.png";